import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
    MainBlockTitle,
    MainBlockWrapper,
    MainBlockSubtitle,
    MainBlockButton,
    SecondaryBlockContainer,
} from '../../../for-businesses/components/constructor/styled';
import { useNavigate } from 'react-router-dom';
import { handleDownloadClick } from 'utils';

interface SecondaryBlockProps {
    config: {
        title: string;
        subtitle: string;
        link: string;
        downloadLink?: {
            fileName: string;
        };
        buttonLabel?: string;
        onDownload?: () => void;
    };
}

export const SecondaryBlock: FC<SecondaryBlockProps> = ({
    config: { title, subtitle, link, downloadLink, buttonLabel, onDownload },
}) => {
    const { t } = useTranslation('pages/for-businesses');
    const navigate = useNavigate();

    return (
        <SecondaryBlockContainer
            to={link}
            onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                if (onDownload) {
                    onDownload();
                }

                if (downloadLink) {
                    return handleDownloadClick(e, downloadLink.fileName, link);
                }
            }}>
            <MainBlockWrapper secondary>
                <MainBlockTitle>{title}</MainBlockTitle>
                <MainBlockSubtitle>{subtitle}</MainBlockSubtitle>
                <MainBlockButton
                    secondary
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        if (onDownload) {
                            onDownload();
                        }

                        if (downloadLink) {
                            return handleDownloadClick(
                                e,
                                downloadLink.fileName,
                                link
                            );
                        }

                        return navigate(link);
                    }}
                    variant={'outlined'}
                    color={'primary-contrast'}
                    size={'large'}>
                    {buttonLabel ? buttonLabel : t('all-courses')}
                </MainBlockButton>
            </MainBlockWrapper>
        </SecondaryBlockContainer>
    );
};
